import { type FC } from 'react';
import { Dropdown, DropdownProps } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

type ActionDropdownProps = {
  menu: DropdownProps['menu'];
  disabled?: boolean;
};
/**
 * @deprecated Use DropdownMenu
 */
export const ActionDropdown: FC<ActionDropdownProps> = ({ menu, disabled }) => {
  return (
    <Dropdown menu={menu} trigger={['click']} disabled={disabled}>
      <StyledFlex $disabled={Boolean(disabled)}>
        <Icon
          name="dots-three-vertical"
          size="s16"
          style={{ color: disabled ? COLORS.systemDark100 : COLORS.systemDark300 }}
        />
      </StyledFlex>
    </Dropdown>
  );
};

const StyledFlex = styled.div<{ $disabled: boolean }>`
  height: 100%;
  justify-content: center;
  align-items: center;
  cursor: ${(p) => (p.$disabled ? 'default' : 'pointer')};
`;
